<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>Ingreso datos Nueva OT</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
     
		<div class="content-boxed">


  			<div class="content bottom-0">
				
 			<div class="calendar">
				<div class="search-box search-color bg-magenta1-dark shadow-tiny round-huge bottom-0">
					<i class="fa fa-search"></i>
					<input type="text" v-model="datasearchporpatente" @keyup="datasearchfxvehiculo" @input="buscarTodosLosClientes" placeholder="Buscar vehículo por patente" data-search maxlength="6" style="text-transform: uppercase">
					<a href="#" class="button bg-blue1-dark button-m button-full round bottom-10 shadow-small contactSubmitButton" @click="crearvehiculo" data-formId="dataForm">Nuevo</a>
				</div>
			</div>


 


               <div class="contact-form">
                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit">

						<div data-height="200" class="caption caption-margins round-medium shadow-large">
							<div class="caption-bottom left-20 bottom-15">
								<p class="bottom-0 color-white opacity-50 under-heading font-12">{{ sucursal }}</p>
								<h1 class="color-white bottom-0 bolder">N° Ficha {{ OT.codvehiculo }}</h1>
								<h1 class="color-white bottom-0 bolder">{{ OT.marca }}</h1>
								<h1 class="color-white bottom-0 bolder">{{ OT.modelo }}</h1>
								<h1 class="color-white bottom-0 bolder">{{ OT.agno }}</h1>
								<p class="bottom-0 color-white opacity-50 under-heading font-12">{{ OT.vin }}</p>
								<h1 class="color-white bottom-0 bolder">{{ OT.placapatente }}</h1>
							</div>
							<div class="caption-overlay bg-black opacity-75"></div>
							<div class="caption-bg bg-29"></div>
						</div>   

						<div class="calendar">
							<div class="search-box search-color bg-magenta1-dark shadow-tiny round-huge bottom-0">
								<i class="fa fa-search"></i>
								<input id="InputCliente" type="text" v-model="datasearchporrut" @keyup="datasearchfxcliente(datasearchporrut)" placeholder="Buscar cliente por rut" data-search maxlength="9" style="text-transform: uppercase">
								<a	href="#" class="button bg-green2-dark button-m button-full round bottom-10 shadow-small contactSubmitButton" @click="crearcliente" data-formId="dataForm">Nuevo</a>
							</div>
						</div>
						<div v-if="tipoCliente == 3" data-height="150" class="caption caption-margins round-medium shadow-large">
							<div class="caption-bottom left-20 bottom-15">
								<h2 class="color-white bottom-0 bolder">{{ Cliente.nombre }}</h2>
								<br>
								<p class="bottom-0 color-white under-heading font-12">{{ Cliente.fono1 }}</p>
							</div>
							<div class="caption-overlay bg-black opacity-75"></div>
							<div class="caption-bg bg-27"></div>
						</div>
						<div v-else data-height="150" class="caption caption-margins round-medium shadow-large">
							<div class="caption-bottom left-20 bottom-15">
								<h2 class="color-white bottom-0 bolder">{{ Cliente.nombre }}</h2>
								<h2 class="color-white bottom-0 bolder">{{ Cliente.paterno }}</h2>
								<h2 class="color-white bottom-0 bolder">{{ Cliente.materno }}</h2>
								<br>
								<p class="bottom-0 color-white under-heading font-12">{{ Cliente.fono1 }}</p>
							</div>
							<div class="caption-overlay bg-black opacity-75"></div>
							<div class="caption-bg bg-27"></div>
						</div>
						
						<div class="calendar" id="divClientes" style="display: none;">
							<div style="width: 100%;" class="search-box search-color bg-magenta1-dark shadow-tiny round-huge bottom-0">
								<select class="form-select form-select-lg mb-3 bg-magenta1-dark" id="Clientes" style="width: 95%;" @change="clienteSeleccionado">
								</select>
							</div>
						</div>


						<div v-if="!blnCreaVehiculo" class="content-boxed">
								<a href="#" class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="siguiente" data-formId="dataForm">Crear Orden de trabajo</a>
						</div>

                    </form>			
                </div>
            </div>

 


    	</div>
		
    </div>


</template>

<script>

import * as db from "../../database.js";
import * as validate from "../../validate.js";

export default {
	data() {
      return {
		codsucursal:JSON.parse(localStorage.getItem('user')).codsucursal,
		sucursal:JSON.parse(localStorage.getItem('user')).sucursal,
		tipoCliente: 0,

		Direccioncliente:{},
		OT:{
			codvehiculo:0,
			placapatente:"",
			agno:0,
			codmarca:0,
			codmodelo:0,
			marca:"",
			modelo:"",
			vin:""
		},

		Cliente:{
			codcliente:0,
			nombre:"",
			paterno:"",
			materno:"",
			fono1:"",
			},


		}
	},

	mounted() {
		if(localStorage.getItem('searchplacapatente')!=null && localStorage.getItem('searchplacapatente')!="")
			{
			this.datasearchporpatente=localStorage.getItem('searchplacapatente');
			this.datasearchfxvehiculo();
			}

		if(localStorage.getItem('searchcliente')!=null && localStorage.getItem('searchcliente')!="")
			{
			this.datasearchporrut=localStorage.getItem('searchcliente');
			let rut = localStorage.getItem('searchcliente');
			this.datasearchfxcliente(rut);
			}

	},


	methods: {

	datasearchfxvehiculo()
	{
		let codsucursal=JSON.parse(localStorage.getItem('user')).codsucursal;
		if(this.datasearchporpatente!="" && this.datasearchporpatente.length>=6)
			db.getFx("ot.buscarvehiculoporpatente",'{"datasearch":"'+this.datasearchporpatente+'","codsucursal":"'+codsucursal+'"}')   .then(result => {if (result.data.err!="")
			{
				this.OT.placapatente=(this.datasearchporpatente).toUpperCase();
				localStorage.setItem('searchplacapatente',this.OT.placapatente);
				alert(result.data.err);
				console.log (result.data.err);
			}

		else{

			this.OT=result.data.data
			if(this.OT.rut!="")
			{
				this.datasearchporrut=this.OT.rut;
				let rut = this.OT.rut;
				this.datasearchfxcliente(rut);
			}

		}});
	},

	datasearchfxcliente(rut)
	{
	let codsucursal=JSON.parse(localStorage.getItem('user')).codsucursal;
	if(rut!="" && rut.length>=8)
		db.getFx("ot.buscarclienteporrut",'{"datasearch":"'+ rut +'","codsucursal":"'+codsucursal+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			console.log(result.data.data)
			this.Cliente=result.data.data

			db.getFx2("ot.buscartipocliente", '{"datasearch":"' + this.Cliente.codcliente +'"}') .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				this.tipoCliente = result.data.data
				console.log(this.tipoCliente);
			}});
		}});
	},

	buscarTodosLosClientes()
	{
		let codsucursal=JSON.parse(localStorage.getItem('user')).codsucursal;
		if(this.datasearchporpatente!="" && this.datasearchporpatente.length>=6)
			db.getFx2("ot.buscarclienteporpatente",'{"datasearch":"'+this.datasearchporpatente+'","codsucursal":"'+codsucursal+'"}')   .then(result => {if (result.data.err!="")
			{
				// alert(result.data.err);
				// console.log (result.data.err);

				document.getElementById("divClientes").style.display = "none";
			}
			else
			{
				let clientes = result.data.data;

				let selectClientes = document.getElementById('Clientes');

				selectClientes.innerHTML = '';

                let optionPlaceholder = document.createElement('option');
                optionPlaceholder.disabled = true;
                optionPlaceholder.selected = true;
                optionPlaceholder.hidden = true;
                optionPlaceholder.textContent = 'SELECCIONE UN CLIENTE';
                selectClientes.appendChild(optionPlaceholder);

				document.getElementById("divClientes").style.display = "flex";

				clientes.forEach(cliente => {
					// Crea un elemento option
					let option = document.createElement('option');
					
					// Asigna el valor y texto al option
					option.value = cliente.rut + cliente.dv; 
					option.textContent = cliente.nombre; 
					
					// Agrega el option al select
					selectClientes.appendChild(option);
				});
			}
		});
	},

	clienteSeleccionado(event) {
        // Obtén el valor del cliente seleccionado
        let valorCliente = event.target.value;
                
        // Asignar el valor del cliente seleccionado al input
		document.getElementById('InputCliente').value = valorCliente;

		// Disparar el evento keyup para ejecutar la búsqueda del cliente
		document.getElementById('InputCliente').dispatchEvent(new Event('keyup'));

		this.datasearchporrut=valorCliente;

		this.datasearchfxcliente(valorCliente);
    },

	crearvehiculo()
	  {
		localStorage.setItem('editcodvehiculo',"");

		window.location="/Newvehiculo";
          //this.$router.push('/ClientNew/'+OT.placapatente);
	  },
	crearcliente()
	  {		  
		localStorage.setItem('editcodcliente',"");
		window.location="/Newcliente";
          //this.$router.push('/ClientNew/'+OT.placapatente);
	  },


		siguiente() {
			let codusuario = JSON.parse(localStorage.getItem('user')).codusuario;

			db.getFx("ot.crearOT", '{"codcliente":"' + this.Cliente.codcliente + '","codvehiculo":"' + this.OT.codvehiculo + '","codasesor":"' + codusuario + '"}').then(result => {
				if (result.data.err != "") { alert(result.data.err); console.log(result.data.err); console.log("Error") } else {

					localStorage.setItem('searchplacapatente', "");
					localStorage.setItem('searchcliente', "");

					localStorage.setItem('idcotizacionvehiculo', result.data.data.idcotizacionvehiculo)
					localStorage.setItem('idagenda', result.data.data.idagenda)
					localStorage.setItem('fechaagenda', result.data.data.fechaagenda)
					localStorage.setItem('horaagenda', result.data.data.hora)

					window.location = "/Wizardot2data"
				}
			});
			//Ingresar OT
		}

	}
}

</script>

<style>
	select#Clientes option:hover {
		background-color: #8D7FB1; /* Cambia "tu-color-aqui" por el color deseado */
	}
</style>
